import { IconCards, IconTable } from '@tabler/icons-react';
import classNames from 'classnames';
import { NSButton } from 'bricks';
import { UsesView } from 'views/ProFormaTable/types';

interface Props {
    value: UsesView;
    onChange: (next: UsesView) => void;
}

const UsesCardsViewToggle = ({ value, onChange }: Props) => (
    <div className="d-inline-flex">
        <NSButton
            icon={IconCards}
            size="sm"
            ariaLabel="Cards view"
            ariaPressed={value === 'cards'}
            allowReadOnlyAccess
            className={classNames({
                'bg-secondary border-secondary text-white': value === 'cards',
                'bg-transparent text-muted': value !== 'cards',
            })}
            callback={() => onChange('cards')}
        />
        <NSButton
            icon={IconTable}
            size="sm"
            ariaLabel="Detailed budget table view"
            ariaPressed={value === 'table'}
            allowReadOnlyAccess
            className={classNames({
                'bg-secondary border-secondary text-white': value === 'table',
                'bg-transparent text-muted': value !== 'table',
            })}
            callback={() => onChange('table')}
        />
    </div>
);

export default UsesCardsViewToggle;
